"use client"

import * as React from "react"
import { Progress as ProgressPrimitive } from "radix-ui"

import { cn } from "@/lib/util"

function Progress({
  className,
  value,
  // Restored after a registry install overwrote this file: the indicator is
  // the page's own gradient here, not `bg-primary`, and callers pass extra
  // classes for it.
  indicator = '',
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & { indicator?: string }) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={`bg-gradient h-full w-full flex-1 transition-all ${indicator}`}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
